/* Publish by EComposer at 2026-11-03 17:08:27*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-00cu7dqbl338l"]=  window.__ectimmers["ecom-00cu7dqbl338l"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-00cu7dqbl338l').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-00cu7dqbl338l', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-00cu7dqbl338l', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-txla6m1x3zj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-txla6m1x3zj', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-txla6m1x3zj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1y6ivrxrbn6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1y6ivrxrbn6', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1y6ivrxrbn6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yg3tmvmptv').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yg3tmvmptv', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yg3tmvmptv', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-mgdpvr33i1').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-mgdpvr33i1', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-mgdpvr33i1', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gredg039ztm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gredg039ztm', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gredg039ztm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-esfmscocqdg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-esfmscocqdg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-esfmscocqdg', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ty1dnzradc').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ty1dnzradc', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ty1dnzradc', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9xugl8q949u').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9xugl8q949u', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9xugl8q949u', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-dxek976n9bb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-dxek976n9bb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-dxek976n9bb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4jx8tro1wrq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4jx8tro1wrq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4jx8tro1wrq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6o9t7ssoxb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6o9t7ssoxb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6o9t7ssoxb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4r1awrjuxoe').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4r1awrjuxoe', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4r1awrjuxoe', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-wkd5a0dalab').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-wkd5a0dalab', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-wkd5a0dalab', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-drvcnbvi5j7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-drvcnbvi5j7', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-drvcnbvi5j7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-d244jn1ygqs').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-d244jn1ygqs', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-d244jn1ygqs', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-pb3sy98wp57').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-pb3sy98wp57', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-pb3sy98wp57', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6m8mhbebx6x').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6m8mhbebx6x', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6m8mhbebx6x', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-jvwoxs4bwkd').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-jvwoxs4bwkd', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-jvwoxs4bwkd', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3knphe0d6n6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3knphe0d6n6', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3knphe0d6n6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6586vaqzk8c').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6586vaqzk8c', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6586vaqzk8c', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-eq94xacab5').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-eq94xacab5', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-eq94xacab5', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-un793ep9ot').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-un793ep9ot', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-un793ep9ot', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gnrgjqjhbb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gnrgjqjhbb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gnrgjqjhbb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8c4a68eywii').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8c4a68eywii', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8c4a68eywii', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-73qiiqfj2z8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-73qiiqfj2z8', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-73qiiqfj2z8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ltwjmxo0gxn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ltwjmxo0gxn', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ltwjmxo0gxn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-n1cc0buaink').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-n1cc0buaink', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-n1cc0buaink', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5sk101tiwip').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5sk101tiwip', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5sk101tiwip', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-e8v4kidueak').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-e8v4kidueak', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-e8v4kidueak', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-aq6bdgankan').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-aq6bdgankan', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-aq6bdgankan', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-97k4tpc232n').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-97k4tpc232n', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-97k4tpc232n', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-bqlwprn7kcs').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-bqlwprn7kcs', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-bqlwprn7kcs', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rpiz2rv4epf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rpiz2rv4epf', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rpiz2rv4epf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2cpzas9k9jq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2cpzas9k9jq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2cpzas9k9jq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-a80c64kd7y7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-a80c64kd7y7', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-a80c64kd7y7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-u9c5fhleu6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-u9c5fhleu6', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-u9c5fhleu6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ahb30njmd2c').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ahb30njmd2c', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ahb30njmd2c', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-oi7ocizhni').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-oi7ocizhni', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-oi7ocizhni', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-mlq9ewh16x').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-mlq9ewh16x', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-mlq9ewh16x', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9clbqudo1uf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9clbqudo1uf', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9clbqudo1uf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-uoi6kw4kam').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-uoi6kw4kam', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-uoi6kw4kam', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-owhk6oxkrt').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-owhk6oxkrt', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-owhk6oxkrt', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3f63zqme8gb"]=  window.__ectimmers["ecom-3f63zqme8gb"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-3f63zqme8gb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3f63zqme8gb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3f63zqme8gb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ylfj1dxen3o').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ylfj1dxen3o', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ylfj1dxen3o', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-oy9rsgi45po"]=  window.__ectimmers["ecom-oy9rsgi45po"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-oy9rsgi45po"]["8cpsjz0gl"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-oy9rsgi45po').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-oy9rsgi45po', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-oy9rsgi45po', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-g44sc46tzjq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-g44sc46tzjq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-g44sc46tzjq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qgzugl0ziuj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qgzugl0ziuj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qgzugl0ziuj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ng9xp22xrxh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ng9xp22xrxh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ng9xp22xrxh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ctodj5ju5af').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ctodj5ju5af', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ctodj5ju5af', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-i7xj5bgyapj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-i7xj5bgyapj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-i7xj5bgyapj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-b2s5wiifok').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-b2s5wiifok', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-b2s5wiifok', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-b4n6egw00oo"]=  window.__ectimmers["ecom-b4n6egw00oo"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-b4n6egw00oo"]["sd0hxktwe"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-b4n6egw00oo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-b4n6egw00oo', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-b4n6egw00oo', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-who7qnwuhf"]=  window.__ectimmers["ecom-who7qnwuhf"] || {};
var $,E,I,j,M,D;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,n=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,s=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(M=this.settings.disable_effect)!=null?M:!1,a=(D=this.settings.close_all)!=null?D:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(T){const F=T.getBoundingClientRect();return F.top>=0&&F.left>=0&&F.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&F.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(T){return o&&T<768||n&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const F=T.style.transition;T.style.transition="none",T.style.height="auto";const H=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=F,requestAnimationFrame(()=>{const R=r?"auto":e?H+"px":"auto";T.style.height=R})}function y(T){T.classList.remove("ecom-item-active");const F=T.querySelector(":scope > .ecom-accordion__body");F&&(r||(F.style.height=F.scrollHeight+"px",F.offsetHeight),requestAnimationFrame(()=>{F.style.height="0px"}))}function v(T){let F=0;if(T.offsetParent)do F+=T.offsetTop;while(T=T.offsetParent);return F}function w(T){const F=Math.max(0,T),H=window.pageYOffset||document.documentElement.scrollTop,R=F-H;if(R===0)return;const K=300;let W=null;function G(se){W||(W=se);const te=Math.min((se-W)/K,1),Y=te<.5?2*te*te:1-Math.pow(-2*te+2,2)/2;window.scrollTo(0,H+R*Y),te<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function S(T){w(v(T)-100)}function C(T,F=!1){T.forEach((H,R)=>{const K=H.parentNode,W=K.querySelector(":scope > .ecom-accordion__body");!r&&W&&W.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");W&&!a&&(F&&R===0||G)&&requestAnimationFrame(()=>{W.style.height=W.scrollHeight+"px"}),H.onclick=function(se){var ue,_e;if(se.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const te=m(),Y=this.parentNode,pe=Y.parentNode,de=pe.querySelectorAll(":scope > .ecom-accordion__item"),he=Array.from(de).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const V=this.classList.contains("ecom-item-active"),X=_(te);if(V)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(de.forEach(y),he.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(de.forEach(y),he.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),H.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(ue=we.parentElement)==null?void 0:ue.closest)==null?void 0:_e.call(ue,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const Q=this,ge=s||te>1024;function ee(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(Q)&&S(Q)}if(ge&&!r){let we;const Ae=function(Ee){Ee.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},50))};pe.addEventListener("transitionend",Ae),setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},600)}else requestAnimationFrame(()=>{setTimeout(ee,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function x(){const T=window.location.hash;if(T){const F=t.querySelector(`[data-target="${T}"]`);if(F){F.click(),F.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=F.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(x,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",x,!1)

                    });
                    
                        document.querySelectorAll('.ecom-who7qnwuhf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-who7qnwuhf', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-who7qnwuhf', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-38ehz0n8tzx"]=  window.__ectimmers["ecom-38ehz0n8tzx"] || {};
if(!this.$el)return!1;const t=this.$el;let e=t.closest(".ecom-product-form--single");if(!e){const n=t.closest(".ecom-builder");n&&(e=n.querySelector(".ecom-product-form--single"))}if(!e)return!1;if(this.isLive){let n=e.querySelector("[name=id]");const s=(n?parseInt(n.getAttribute("ec-variants")):0)>250||e.querySelector("[data-high-variant-product]"),r=t.querySelector(".ecom-product-single__buy_it_now_btn--checkout"),a=e.dataset.product_id;if(!a)return;let l=null;const c=e.querySelector("[id^=product-json-"+a+"]");if(!c)return;try{l=JSON.parse(c.innerHTML)}catch(d){return}r&&r.addEventListener("click",function(d){d.preventDefault();let p=1;e.querySelector("[name=quantity]")&&(p=e.querySelector("[name=quantity]").value);let m=e.querySelector("select[name=id]")||e.querySelector("input[name=id]");m||console.warn("EC error: Select id or input id not found!");let _=m.value,b=null;if(s?b=l:b=l.variants.find(v=>v.id==_),!b||b.available===!1)return;window.Shopify.analytics&&Shopify.analytics.publish("ec_buy_now",{cartLine:{cost:{totalAmount:{amount:b.price*p,currencyCode:window.Shopify.currency.active}},merchandise:{id:b.id,image:b.image,price:{amount:b.price,currencyCode:window.Shopify.currency.active},product:{id:l.id,title:l.title,vendor:l.vendor},sku:b.sku,title:b.title},quantity:p}});let y=`${window.EComposer.routes.cart_url}/${_}:${p}`;if(window.location.search.includes("selling_plan")){const v=/selling_plan=(\d+)/,w=window.location.search.match(v);if(w){const S=w[1];y=`${window.EComposer.routes.cart_url}/clear?return_to=/cart/add?items[][id]=${_}%26items[][quantity]=${p}%26items[][selling_plan]=${S}%26return_to=/checkout`}}location.href=y}),l.available||(r.classList.add("ecom-disable-buy"),r.disabled=!0),n&&e.addEventListener("ecomVariantChange",function(d){let p=d.detail.variant;!p||p.available===!1?(r.classList.add("ecom-disable-buy"),r.disabled=!0):(r.classList.remove("ecom-disable-buy"),r.disabled=!1)})}const i=function(n){if(!t)return;const o=t.querySelector(".ecom-product-single__buy_it_now_btn--checkout");if(!o)return;let s=parseInt(n.settings.animation_loop_time)*1e3||6e3,r=1e3;window.__ectimmers["ecom-38ehz0n8tzx"]["fmsanwfml"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},r)},s)};this.settings.animation&&i(this)

                    });
                    
                        document.querySelectorAll('.ecom-38ehz0n8tzx').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-38ehz0n8tzx', settings: {"animation":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-38ehz0n8tzx', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-h6qrh1frjmo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-h6qrh1frjmo', settings: {"animation":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-h6qrh1frjmo', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}